import apiService from './apiService';
import apiServiceNew from './apiService.new';
import appConfigService from '_app/services/appConfigService';
import {stringify} from 'query-string';

export default (function () {

	var servicePath = '/Media';
	var parseOptions = {
		'datetimes': ['CreateDate', 'ModifyDate']
	};

	const mediaHubSearchResultsPath = 'media/searchResults';
	const mediaEmailAttachmentsPath = 'media/emailAttachmentsSearch';

	// Create media item
	function create(record) {
		return apiService
			.post(JSON.stringify(mediaOutputMapper(record)), servicePath)
			.done(function (data) {
				apiService.parse(data, parseOptions);
				return data;
			});
	}

	// helper method to return the version to display given media and versions
	// @param {object} media
	// @param {object} versions - where keys are the Version number
	function displayVersion(media, versions) {
		media = media || {};
		versions = versions || {};
		if (media.PrimaryVersion) {
			return versions[media.PrimaryVersion];
		}
		const keys = Object.keys(versions).sort(function (a, b) {
			return parseInt(a) - parseInt(b);
		});

		return versions[keys.pop()];
	}

	// Perform search
	function search(params) {
		var url = servicePath + '/search' + apiService.paramsToQuery(params);

		return apiService
			.get(url)
			.then(function (data) {
				var list = data.result;

				if (list instanceof Array) {
					for (let i = 0; i < list.length; i++) {
						apiService.parse(list[i], parseOptions);
					}
				}
				return data;
			});
	}

	function get(id) {
		return apiService.getParsed(servicePath + '/' + id, parseOptions);
	}

	function getPublic(id, token) {
		var url = servicePath + '/' + id + '/public'
			+ apiService.paramsToQuery({
				token: token
			});

		return apiService.get(url);
	}

	function getShareTemplate(id) {
		var url = servicePath + '/' + id + '/sharetemplate';

		return apiService.get(url)
			.then(function (data) {
				apiService.parse(data);
				return data;
			});
	}

	function favorite(id, fav) {
		var url = servicePath + '/' + id + '/fav?fav=' + (fav ? 'true' : 'false');

		return apiService.get(url)
			.then(function (data) {
				apiService.parse(data);
				return data;
			});
	}

	function update(record) {

		return apiService.put(JSON.stringify(mediaOutputMapper(record)), servicePath);
	}

	function remove(id) {
		var url = servicePath + '/' + id;

		return apiService.delete(null, url);
	}

	function getSearchSuggestions(filter, searchText, suggestionsDisplayCount, proxiedAsUserId) {
		const params = getGlobalSearchParams(searchText, filter, proxiedAsUserId);

		params.Limit = suggestionsDisplayCount;

		return apiServiceNew.get(mediaHubSearchResultsPath, {
			params: params
		});
	}

	function getGlobalSearchMedia(selectedSection, searchText, offset, proxiedAsUserId) {
		const params = getGlobalSearchParams(searchText, selectedSection, proxiedAsUserId);

		params.Offset = offset;
		params.Limit = 10;

		return apiServiceNew.get(mediaHubSearchResultsPath, {
			params: params
		});
	}

	const getGlobalSearchParams = (searchText, sectionId, proxiedAsUserId) => ({
		SearchTerm: searchText,
		SectionId: sectionId,
		IncludeEmailSection: appConfigService.get('allowEmail'),
		IncludeCampaigns: appConfigService.get('allowCampaign'),
		ProxiedAsUserId: proxiedAsUserId
	});

	const mediaOutputMapper = media => ({
		...media,
		IsFavorite: null
	});

	const getMediaEmailAttachments = (mediaParams) => {
		return apiServiceNew.get(mediaEmailAttachmentsPath, {
			params: {
				...mediaParams
			},
			paramsSerializer: params => {
				return stringify(params, {
					arrayFormat: 'index'
				});
			}
		});
	};

	return {
		create: create,
		displayVersion: displayVersion,
		get: get,
		getPublic: getPublic,
		getShareTemplate: getShareTemplate,
		favorite: favorite,
		search: search,
		update: update,
		remove: remove,
		getSearchSuggestions: getSearchSuggestions,
		getGlobalSearchMedia: getGlobalSearchMedia,
		getMediaEmailAttachments: getMediaEmailAttachments
	};
})();